import CharacterClass from './CharacterClass'

export const armorTypes: { [key: string]: CharacterClass[] } = {
  Cloth: ['Mage', 'Priest', 'Warlock'],
  Leather: ['Demon Hunter', 'Druid', 'Monk', 'Rogue'],
  Mail: ['Evoker', 'Hunter', 'Shaman'],
  Plate: ['Death Knight', 'Paladin', 'Warrior'],
}
